import _ from 'underscore';

/**
 * Given a `path` to a property on the object `o`,
 * try to get the property or return the `defaultValue`.
 *
 * Example:
 *
 * getProperty(null, 'a.b.c', 2); // 2
 * getProperty({ a: { b: { c: 1 } } }, 'a.b.c', 2); // 1
 * getProperty({ a: { b: 1 } }, 'a.b.c', 2); // 2
 */
export const getProperty = (o: any, path: string, defaultValue: any) => _.get(o, path.split('.'), defaultValue);
